<style src="css/rule.css" scoped></style>
<template>
    <div style="padding-top: 1rem;min-height: 100vh;background: #fff">
        <topbar text="规则介绍"></topbar>
        <div class="mainBox">
            <div class="synopsis">简介:</div>
            <div class="synopsisContent">创作中心是我们平台给咨询师的重要功能之一，咨询师可自行创作心理学相关内容，必须属于原创作品。</div>
            <div class="use">使用规范:</div>
            <div class="num">1.声明原创的条件</div>
            <div class="itemBox">
                <i class="circular"></i>
                由咨询师自行创作，且对作品拥有合法版权的内容；
            </div>
            <div class="itemBox">
                <i class="circular"></i>
                若产生版权纠纷问题，我们平台概不负责，由咨询师本人负责；
            </div>
            <div class="itemBox">
                <i class="circular"></i>
                文章审核通过后，默认授权我们使用，我们可对该文章进行修改；
            </div>
            <div class="itemBox">
                <i class="circular"></i>
                文章发布成功后，可获得我们咨询师的个人【专属标识】。
            </div>
        </div>
    </div>
</template>
<script>
    import {getSource, getSources} from "../api"
    import moment from 'moment/moment'
    import {serialize} from 'utils/index'
    import topbar from 'components/topbar'

    export default {
        data() {
            return {
                EnvUrl: `https://cdn.ysqingxin.com/`,
                title:'',
                content:'',
                pic:'',
                file:'',
                token:'',
            }
        },
        components: {
            topbar,
        },
        computed: {},
        filters: {
            time(value){
                let transTime = moment(value).format('YYYY-MM-DD HH:mm:ss')
                return transTime
            },

        },
        methods: {
            change(e) {
                this.file = e.target.files[0]
                // if (this.size) {
                //     let filesize = e.target.files[0].size
                //     if (filesize > 20971520) {
                //         alert('图片不可以超过20M')
                //     }
                // }
                this.getToken()

            },
            async getToken() {
                let url = `/bear-scale/api/qiniu/obtainPictureUploadToken.json`

                let response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: ""
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.code === 0) {
                    this.token = data.token
                    this.uploadImg()
                }
            },
            async getTokenVueHtml5Editor() {
                let url = `/bear-scale/api/qiniu/obtainPictureUploadToken.json`

                let response = await fetch(url, {
                    method: "POST",
                    credentials: "include",
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    body: ""
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.code === 0) {
                    this.token = data.token
                }
            },
            async uploadImg() {
                let formdata = new FormData()
                formdata.append("token", this.token)
                formdata.append("file", this.file)
                let response = await fetch("http://up.qiniu.com", {
                    method: "POST",
                    mode: "cors",
                    body: formdata
                }).catch((error) => {
                    console.log(error)
                })

                let data = await response.json().catch((error) => {
                    console.log(error)
                })

                if (data.key) {
                    this.pic =  data.key
                }
            },
            updateData(content){
                this.content=content
            },
            back(){
                history.back()
            },
            to(n) {
                this.$router.push(`/${n}`)
            },
            getCookie(key) {
                let cookieStr = document.cookie.split("; ");
                for (let i = 0; i < cookieStr.length; i++) {
                    let tempArr = cookieStr[i].split("=");
                    if (tempArr[0] == key) {
                        return tempArr[1];
                    }
                }
                return null;
            },

            async medorderwriteoff(id) {
                let data = await getSources(
                    "/depression-mip/api/medquestion/medorderwriteoff", `orderId=${id}&orderType=1`);
                if (data.status == 0) {
                    this.mask1=true;
                } else {
                    alert(`${data.msg}`);
                }
            },

        },
        destroyed(){
            window.removeEventListener('scroll', this.handleScroll);//监听页面滚动事件
        },
        mounted() {
            // this.getTokenVueHtml5Editor()
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/rules.vue